
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Badge } from "../../components/ui/badge";
import { Clock } from "lucide-react";
import { Lead } from '../../types/crm';

interface InteractionHistoryModalProps {
  lead: Lead | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  statusOptions: { id: number; value: string }[];
}

const InteractionHistoryModal = ({ lead, open, onOpenChange, statusOptions = [] }: InteractionHistoryModalProps) => {
  if (!lead || !lead.interactions) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto bg-white border border-[#d9cba6]/30">
        <DialogHeader className="border-b border-[#d9cba6]/20 pb-4">
          <DialogTitle className="text-xl text-gray-900">
            Interaction History - {lead.companyName}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-2 pt-2">
          {lead.interactions.length === 0 ? (
            <p className="text-gray-500 text-center py-8">No interactions recorded yet.</p>
          ) : (
            lead.interactions.map((interaction) => {
              const statusObj = Array.isArray(statusOptions) ? statusOptions.find(opt => opt.id === interaction.leadStatusId) : undefined;
              return (
                <div key={interaction.id} className="flex gap-4 p-2 bg-gradient-to-r from-[#d9cba6]/10 to-[#e5d7b3]/10 rounded-lg border border-[#d9cba6]/20">
                  <div className="flex-shrink-0">
                    <div className="w-3 h-3 bg-[#d9cba6] rounded-full mt-2"></div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <Badge 
                        variant="outline" 
                        className="border-[#d9cba6]/50 text-[#8b7355]"
                      >
                        {statusObj ? statusObj.value : 'New'}
                      </Badge>
                      <div className="flex items-center gap-1 text-sm text-gray-500">
                        <Clock className="h-3 w-3" />
                        {new Date(interaction.date).toLocaleDateString("en-GB")} at {new Date(interaction.date).toLocaleTimeString()}
                      </div>
                    </div>
                    {interaction.reason && (
                      <p className="text-sm text-gray-600 mb-2">
                        <span className="font-medium">Reason:</span> {interaction.reason}
                      </p>
                    )}
                    {interaction.remark && (
                      <p className="text-sm text-gray-800 ">
                        <span className="font-medium">Remark:</span> {interaction.remark}
                      </p>
                    )}
                    {interaction.nextFollowUp && (
                      <p className="text-sm text-[#8b7355] font-medium">
                        Next follow-up: {new Date(interaction.nextFollowUp).toLocaleDateString("en-GB")}
                      </p>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InteractionHistoryModal;
